module.exports = __webpack_public_path__ + "static/empty-states-ctas-do-b058c9a2611d50c179d7f40e49c18e7e.png";